/* eslint-disable @typescript-eslint/no-explicit-any */
import requsetMarketPlace from 'utils/requestMatketPlace';

const reviewsService = {
  getListfeedbackNotification: (params: any) =>
    requsetMarketPlace.get('system-feedback-notification', { params }),
  getListReviewsProducts: (params: any) =>
    requsetMarketPlace.get('/system-product-feedback', { params }),
  createReviewsReplay: (data: any) =>
    requsetMarketPlace.post('/system-reply-feedback', data),
  getListReviewsStores: (params: any) =>
    requsetMarketPlace.get('/system-store-feedback', { params })
};

export default reviewsService;
